<template>
  <!-- Loading -->
  <Loading v-if="isLoading" :lottieSrc="lottieUrl" />

  <!-- App -->
  <div v-else>
    <router-view />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Loading from './components/LoadingScreen.vue'

const lottieUrl =
  'https://lottie.host/80749ac8-12df-4bec-959b-847f90e40941/QemmUgZuhH.lottie'

const isLoading = ref(true)
const route = useRoute()

const isMobile = () => window.innerWidth <= 768


const autoScrollMobileHome = () => {
  document.documentElement.style.overflowX = 'hidden'
  document.body.style.overflowX = 'hidden'

  window.scrollTo({
    top: document.documentElement.scrollHeight,
    left: 0,
    behavior: 'smooth'
  })

  setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, 1200)
}

onMounted(() => {
  if (isMobile() && route.path === '/') {
    autoScrollMobileHome()
  }

  setTimeout(() => {
    isLoading.value = false

    window.scrollTo(0, 0)
  }, 4000)
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden !important;
}

#app {
  width: 100%;
  overflow-x: hidden;
}
</style>
